import { render, staticRenderFns } from "./Render.vue?vue&type=template&id=2ed134bc&scoped=true&"
import script from "./Render.vue?vue&type=script&lang=js&"
export * from "./Render.vue?vue&type=script&lang=js&"
import style0 from "./Render.vue?vue&type=style&index=0&id=2ed134bc&scoped=true&lang=css&"
import style1 from "./Render.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed134bc",
  null
  
)

export default component.exports